import {Injectable} from "@angular/core";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import {Event} from "../interfaces/event";
import {TeacherService} from "./teacher.service";
import {Teacher} from "../interfaces/teacher";

@Injectable({
  providedIn: "root"
})
export class EventService{
  private db = firebase.firestore();
  constructor(private teacherService: TeacherService) {}
  teacher: Teacher | null = null;

  /** Fetch all Events */
  async getEvents(): Promise<Event[]> {
    this.teacher = await this.teacherService.getTeacher();
    const snapshot = await this.db.collection('event').get();
    const events: Event[] = [];

    snapshot.forEach(doc => {
      const data = { id: doc.id, ...doc.data() } as Event;
      if (this.teacher?.role.toLowerCase() === 'admin' || !data.isDeleted) {
        events.push(data);
      }
    });
    return events;
  }
}
